import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import axios from "axios";
import { SERVER_PATH } from "../../../config/env";
import { FadeLoader } from "react-spinners";
import { userInfo } from "../../../utils/appInfo";
import { getLocalStorage } from "../../../utils/helper";
import { errorToaster } from "../../../utils";
import { formatProductText } from "../../../utils/productTextFormatter";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#000",
};

export default function HerbalSingleProduct() {
  const navigate = useNavigate();
  const isLogin = getLocalStorage("uid") ? true : false;
  const [herbalProduct, setHerbalProduct] = useState([]);

  const handleBuyNow = (e, productId) => {
    e.preventDefault();
    if (!isLogin) {
      navigate(`/profile/${productId}`);
      return;
    }
    const user = userInfo();
    const userId = user?.email || getLocalStorage("uid");
    if (!userId) {
      errorToaster({ msg: "Please log in to buy products" });
      navigate(`/profile/${productId}`);
      return;
    }

    axios
      .post(`${SERVER_PATH}post/cart.php`, {
        product_id: productId,
        user_id: userId,
        quantity: 1,
      })
      .then(() => {
        navigate(`/cart/${productId}`);
      })
      .catch((err) => {
        console.log(err);
        errorToaster({ msg: "Failed to add product to cart." });
      });
  };

  const fetchData = () => {
    axios
      .post(`${SERVER_PATH}get/all_products.php`, {
        category: "herbal",
      })
      .then((res) => {
        setHerbalProduct(res.data);
      });
  };

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {herbalProduct.length >= 1 ? (
        <>
          {herbalProduct.map((data, index) => {
            return (
              <div className="col-md-3" key={"product" + index}>
                <div
                  className="card mb-4 product-wap rounded-0"
                  style={{ height: "350px" }}
                >
                  <div className="card rounded-0 shadow-none">
                    <img
                      className="card-img rounded-0 img-fluid"
                      style={{ height: "180px", objectFit: "contain" }}
                      src={data.img1}
                      alt={data.product_name}
                    />
                    <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                      <ul className="list-unstyled">
                        <li>
                          <Link
                            className="btn btn-success text-white mt-2"
                            to={`/product/${data.product_id}`}
                          >
                            <AiOutlineEye
                              style={{ fontSize: "1.3em", marginTop: "-3px" }}
                            />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="card-body">
                    <Link to={`/product/${data.product_id}`} className="h3 text-decoration-none">
                      {formatProductText(data.product_name)}
                      <small className="productWeight ms-1">
                        {data.weight}Gms.
                      </small>
                    </Link>
                    <span className="d-block text-secondary my-2">
                      RS.{data.offer_price}
                    </span>
                    <button
                      onClick={(e) => handleBuyNow(e, data.product_id)}
                      className="btn btn-sm w-100 btn-outline-success text-uppercase"
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <>
          <FadeLoader color="#000" size={250} cssOverride={override} />
          <h2 className="text-center mt-3">Loading...</h2>
        </>
      )}
    </>
  );
}
